import { useParams, Navigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleContent from './ArticleContent';
import RelatedArticles from './RelatedArticles';
import NotesCta from '../components/NotesCta';
import { getArticleBySlug, getRelatedArticles } from '@/mocks/notes';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;
  const related = slug ? getRelatedArticles(slug, 3) : [];

  if (!article) {
    return <Navigate to="/notes" replace />;
  }

  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Navbar />
      <main>
        <ArticleContent article={article} />
        <RelatedArticles
          articles={related}
          currentCategory={article.category}
          currentCategoryLabel={article.categoryLabel}
        />
        <NotesCta />
      </main>
      <Footer />
    </div>
  );
}